import AffiliatesListing from './affiliates-listing';

const affiliatesListingConfig = {
  name: 'affiliatesListing',
  class: AffiliatesListing,
  querySelector: {
    affiliatesSwiper: '.affiliates-swiper',
    affiliatesPagination: '.affiliates-pagination',
  },
  querySelectorAll: {},
  options: {},
};

export default affiliatesListingConfig;
